module.exports = __webpack_public_path__ + "static/icora-web-915a1ac0f51337094e24749bddd095fe.png";